import { render, staticRenderFns } from "./backside.vue?vue&type=template&id=1a165887&scoped=true&"
import script from "./backside.vue?vue&type=script&lang=js&"
export * from "./backside.vue?vue&type=script&lang=js&"
import style0 from "./backside.vue?vue&type=style&index=0&id=1a165887&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a165887",
  null
  
)

export default component.exports